var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-progress',[_c('b-progress-bar',{attrs:{"value":_vm.value,"label":_vm.progressValue,"variant":_vm.variant}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }